import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'
import * as XLSX from 'xlsx'

// Função auxiliar para formatar datas no padrão brasileiro
function formatDateToBrazilian(dateStr) {
  if (!dateStr) return ''
  const [year, month, day] = dateStr.split('-')
  return `${day}/${month}/${year}`
}

export async function generatePdf(
  records,
  mainTableHeaders,
  mainTableKeys,
  pdfTitle
) {
  // Título e descrição
  const city = store.state.cidade || 'Cidade'
  const now = new Date()
  const day = String(now.getDate()).padStart(2, '0')
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const year = now.getFullYear()
  const formattedDate = `${day}_${month}_${year}`

  // Nome final do arquivo usa o título passado
  let titlePdfSave = `${pdfTitle.replace(/ /g, '_')}_${city}_${formattedDate}`
  let description_pdf =
    'Atividades realizadas no Programa Saúde na Escola (2025 a 2026)'

  // --- Primeira Página: Tabela Resumo ---
  let doc = new jsPDF(utils.methods.encryptionPdf())

  try {
    const base64data = await utils.methods.fileToBase64(
      store.state.infoMunicipio.brasao
    )

    // Cabeçalho padrão do PDF
    let verticalPosition =
      utils.methods.headerPdf(doc, base64data, pdfTitle, description_pdf) + 6
    const hoje = new Date()
    const dataAtual = `${String(hoje.getDate()).padStart(2, '0')}/${String(
      hoje.getMonth() + 1
    ).padStart(2, '0')}/${hoje.getFullYear()}`

    doc.setFontSize(12)
    doc.text(`Data: ${dataAtual}`, 15, verticalPosition)
    verticalPosition += 8
    doc.text(
      'Atividades Coletivas do PSE realizadas na escola',
      15,
      verticalPosition
    )

    verticalPosition += 2

    // Mapeia os dados dinamicamente usando mainTableKeys
    let data_pdf = records.map((record) =>
      mainTableKeys.map((key) => record[key] || '')
    )

    // Usa os cabeçalhos passados como parâmetro
    doc.autoTable({
      head: [mainTableHeaders],
      body: data_pdf,
      startY: verticalPosition,
      headStyles: {
        fillColor: '#ccc',
        fontSize: 6,
        textColor: '#000',
        halign: 'center',
      },
      bodyStyles: { halign: 'center', fontSize: 6 },
      theme: 'striped',
    })

    // Rodapé padrão do PDF
    utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

    // --- Páginas Detalhes ---
    const detailsHeaders = [
      'Data',
      'Profissional',
      'CBO',
      'Participantes',
      'Atividades',
    ]
    const formatDateToBrazilian = (dateStr) => {
      if (!dateStr) return ''
      if (dateStr.includes('-')) {
        // Formato YYYY-MM-DD
        const [year, month, day] = dateStr.split('-')
        return `${day}/${month}/${year}`
      }
      try {
        return new Date(dateStr).toLocaleDateString('pt-BR')
      } catch (e) {
        return ''
      }
    }

    for (const record of records) {
      // Somente adiciona página de detalhe se houver detalhes
      if (record.details && record.details.length > 0) {
        doc.addPage()
        verticalPosition =
          utils.methods.headerPdf(
            doc,
            base64data,
            pdfTitle,
            `Detalhes: ${record.no_escola || record.inep}`
          ) + 6

        doc.setFontSize(12)
        doc.text(`Data: ${dataAtual}`, 15, verticalPosition)
        verticalPosition += 6
        doc.text(`INEP: ${record.inep}`, 15, verticalPosition)
        verticalPosition += 6
        doc.text(`Escola: ${record.no_escola || ''}`, 15, verticalPosition)
        verticalPosition += 6
        doc.text(`Equipe: ${record.no_equipe || ''}`, 15, verticalPosition)
        verticalPosition += 12
        doc.text(
          'Detalhes das Atividades Coletivas realizadas na escola',
          15,
          verticalPosition
        )

        verticalPosition += 4

        const detailsData = record.details.map((detail) => [
          formatDateToBrazilian(detail.data),
          detail.no_profissional || '-',
          detail.co_cbo || '-',
          detail.nu_participantes || '-',
          detail.tipo_atividade || '-',
        ])

        doc.autoTable({
          head: [detailsHeaders],
          body: detailsData,
          startY: verticalPosition,
          headStyles: {
            fillColor: '#ccc',
            fontSize: 6,
            textColor: '#000',
            halign: 'center',
          },
          bodyStyles: { fontSize: 6, halign: 'center' },
          theme: 'striped',
        })

        utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      }
    }

    doc.save(`${titlePdfSave}.pdf`)
    // vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', { position: 'topRight' });
  } catch (error) {
    console.error('Erro ao gerar PDF:', error)
    // vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', { position: 'topRight' });
    throw new Error('Falha ao gerar PDF')
  }
}

export async function exportTeamPdf(team) {
  const title_pdf = 'PSE'
  const now = new Date()
  const day = String(now.getDate()).padStart(2, '0')
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const year = now.getFullYear()
  const formattedDate = `${day}_${month}_${year}`

  let titlePdfSave = `${title_pdf}_${
    team.no_escola || 'Escola'
  }_${formattedDate}`
  let description_pdf =
    'Atividades realizadas no Programa Saúde na Escola (2025 a 2026)'

  // Cabeçalho
  const detailsHeaders = [
    'Data',
    'Profissional',
    'CBO',
    'Participantes',
    'Atividades',
  ]
  const detailsData = (team.details || []).map((detail) => [
    formatDateToBrazilian(detail.data),
    detail.no_profissional,
    detail.co_cbo,
    detail.nu_participantes,
    detail.tipo_atividade,
  ])

  const doc = new jsPDF(utils.methods.encryptionPdf())

  try {
    const base64data = await utils.methods.fileToBase64(
      store.state.infoMunicipio.brasao
    )
    let verticalPosition =
      utils.methods.headerPdf(doc, base64data, title_pdf, description_pdf) + 6

    const hoje = new Date()
    const dataAtual = `${String(hoje.getDate()).padStart(2, '0')}/${String(
      hoje.getMonth() + 1
    ).padStart(2, '0')}/${hoje.getFullYear()}`

    doc.setFontSize(12)
    doc.text(`Data: ${dataAtual}`, 15, verticalPosition)
    verticalPosition += 6

    doc.text(`INEP: ${team.inep}`, 15, verticalPosition)
    verticalPosition += 6
    doc.text(`Escola: ${team.no_escola || ''}`, 15, verticalPosition)
    verticalPosition += 6
    doc.text(`Equipe: ${team.no_equipe || ''}`, 15, verticalPosition)
    verticalPosition += 12

    doc.text(
      'Atividades Coletivas do PSE realizadas na escola',
      15,
      verticalPosition
    )
    verticalPosition += 4

    doc.autoTable({
      head: [detailsHeaders],
      body: detailsData,
      startY: verticalPosition,
      headStyles: {
        fillColor: '#ccc',
        fontSize: 6,
        textColor: '#000',
        halign: 'center',
      },
      bodyStyles: { fontSize: 6, halign: 'center' },
      theme: 'striped',
    })

    utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
    doc.save(`${titlePdfSave}.pdf`)

    vue.$toast.success('PDF da equipe gerado com sucesso!', 'Sucesso:', {
      position: 'topRight',
    })
  } catch (error) {
    console.error(error)
    vue.$toast.error('Erro ao gerar PDF da equipe', 'Erro:', {
      position: 'topRight',
    })
  }
}

export function exportarXlsCustomizado(
  dados,
  nomeArquivo,
  cidade,
  titulo,
  descricao_secretaria,
  descricao,
  dataAtual,
  subtitulo,
  columnOrder
) {
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.aoa_to_sheet([])
  const subtituloLinhas = subtitulo.split('\n')

  // Header
  const headerRows = [
    [cidade],
    [descricao_secretaria],
    [titulo],
    [descricao],
    [`Data: ${dataAtual}`],
    ...subtituloLinhas.map((linha) => [linha]),
    [],
  ]

  XLSX.utils.sheet_add_aoa(ws, headerRows, { origin: 'A1' })

  const dataStartRow = headerRows.length + 1

  // Se não for passado columnOrder, utiliza a ordem padrão para o PSE principal
  if (!columnOrder) {
    columnOrder = [
      'INEP',
      'Escola',
      'Equipe',
      'Alimentação',
      'Paz',
      'Reprodução',
      'Vacinação',
    ]
  }

  // Adiciona os dados principais (tabela), garantindo a ordem correta das colunas
  XLSX.utils.sheet_add_json(ws, dados, {
    origin: `A${dataStartRow}`,
    header: columnOrder,
  })

  // Adiciona a planilha ao workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Dados')

  // Faz download diretamente
  XLSX.writeFile(wb, `${nomeArquivo}.xlsx`)
}
